/* eslint-disable jsx-a11y/alt-text */
import { masks, cardiver } from "../assets";

const Cardoverlays = params => {
  return (
    <>
    <div  className="modal fade" id="cardOverlay3" tabIndex="-1" aria-labelledby="cardOverlayModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">

          <div className="modal-header hide">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span className="close-btn" aria-hidden="true">
                &times;
              </span>
            </button>
          </div>

          <div className="modal-body padding-0">
    <div className="backcardlay">
      <div className="container overlay-1 backcardlay">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="card overlay-card-1 ">
            <header className="overlay-1-header">
              <h5 className="line-height memphis-mediums">
              Your kid can get breakfast at school for free.
              </h5>
            </header>
            <div className="col-md-12">
              <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
              <label className="container w-checkox memphis-medium color-mistake-pay">
              Get everyone up 45min earlier every day so your kid can get to school in time for breakfast.{" "}
                <span className="brown-texts m-auto Pacifico-Regulars">
                  lose <img src={cardiver} className="width-ovwelay-image" />{" "}
                  money/debt
                </span>
                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 3, 3)} type="radio" />
                <span className="checkmark"></span>
              </label>
              <h5 className="w-set-check mt-2 memphis-medium">OR:</h5>
              <label className="container w-checkox memphis-medium color-mistake-pay">
              Skip the free school breakfast so your kid gets more sleep.
                <span className="yellow-texts m-auto Pacifico-Regulars">
                  {" "}
                  lose <img src={masks} className="width-ovwelay-image" />{" "}
                  time/energy
                </span>
                <input name="cardoverlay1_option[]" onChange={(e) => params.checkCardOverlay(e.target, 3, 1)} type="radio" />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-md-12  text-right mt-4">
              <h6 className="health-overlay-color font-economy memphis-medium">&copy;<span className="ml-1">Health Economy 2019</span></h6>
            </div>
          </div>

          <div className="mt-4">
            <div className="card-overlay-2 bg-overlay">
              <div className="text-center">
                <button onClick={(e) => params.keepOpen(e.target, 3)} type="text" className="overlay-button">
                  Keep Open
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
          </div>
        </div>
      </div>
    </div>

    </>
  );
};

export default Cardoverlays;
